/*
  Menstrosan mängdrabatt | Niclas + Claude | 2026-10-16
  Snabbköp i cart drawer-karusellen: lägger vald storlek i korgen via /cart/add.js och
  låter Dawns egen cart-drawer rendera om (samma väg som produktformuläret).
  Delegerat på document så att det överlever omrendering av drawern.
*/
(function () {
  if (window.msUpsellQuickAdd) return;
  window.msUpsellQuickAdd = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ms-qa-add]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-ms-qa]');
    var select = wrap && wrap.querySelector('select');
    var variantId = select ? select.value : btn.getAttribute('data-variant-id');
    if (!variantId || btn.getAttribute('aria-busy') === 'true') return;

    var drawer = document.querySelector('cart-drawer');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || res.message);
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: variantId, sections: res.sections });
        } else {
          window.location.reload();
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ms-upsell-quickadd', productVariantId: variantId });
        }
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        var msg = wrap && wrap.querySelector('[data-ms-qa-error]');
        if (msg) {
          msg.textContent = err && err.message ? err.message : 'Kunde inte lägga till';
          msg.hidden = false;
        }
      });
  });
})();
